// Shop-floor text highlighting for v2 — SAME rules as the v1 terminal.
//
// Rules live server-side (ShopFloorHighlight, /api/shop-floor/highlights/)
// and are managed from the v1 shop-floor admin bars; v2 only consumes them,
// so one set of settings drives both terminals. product_code === '*' rows
// are global (highlight on every row); any other product_code highlights
// only rows whose item code or name contains it (case-insensitive), exactly
// mirroring getHighlightsForWO/applyHighlight in v1 ShopFloorTerminal.js.

// Raw API rows -> { globals: string[], productRules: [{code, text}] }.
export function splitHighlightRules(rows) {
  const globals = [];
  const productRules = [];
  for (const r of rows || []) {
    const text = (r.highlight_text || '').trim();
    if (!text) continue;
    if (r.product_code === '*') {
      globals.push(text);
    } else {
      const code = (r.product_code || '').trim().toLowerCase();
      if (code) productRules.push({ code, text });
    }
  }
  return { globals, productRules };
}

// Texts to highlight for one row, given its item code + name.
export function highlightsForItem(cfg, itemCode, itemName) {
  if (!cfg) return [];
  const highlights = [...cfg.globals];
  if (cfg.productRules.length) {
    const code = (itemCode || '').toLowerCase();
    const name = (itemName || '').toLowerCase();
    for (const rule of cfg.productRules) {
      if (code.includes(rule.code) || name.includes(rule.code)) {
        highlights.push(rule.text);
      }
    }
  }
  return highlights;
}

// Wrap every occurrence of the highlight texts in a yellow <mark> —
// identical styling to v1 so the floor sees one consistent convention.
export function applyHighlight(text, highlights) {
  if (!highlights || highlights.length === 0 || !text) return text;
  const escaped = highlights
    .filter((h) => h && h.length > 0)
    .map((h) => h.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  if (escaped.length === 0) return text;
  const regex = new RegExp(`(${escaped.join('|')})`, 'gi');
  const parts = String(text).split(regex);
  if (parts.length <= 1) return text;
  return (
    <>
      {parts.map((part, i) => (
        i % 2 === 1
          ? (
            <mark
              key={i}
              style={{
                backgroundColor: '#ffeb3b',
                padding: '0 2px',
                borderRadius: '2px',
                fontWeight: 'bold',
              }}
            >
              {part}
            </mark>
          )
          : part
      ))}
    </>
  );
}
